<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    Employee Cart
    <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>

<div mat-dialog-content class="eip-pxy-20">
  <div class="">
    <EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)'
      (OnClick)='setCartParams()'>
    </EIPGeneralCart>
  </div>
</div>